import { capitalize } from 'lodash';

export abstract class StringUtils {

  public static cut(text: string, start: number | string, end: number | string) {
    start = (typeof start === 'number') ? start : (text.indexOf(start) + start.length);
    end = (typeof end === 'number') ? end : text.indexOf(end);
    return text.slice(start, end);
  }

  public static normalize(text: string): string {
    return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  /**
   * Deixe uma string mais segura
   * ! DEVE SER APLICADO EM QUALQUER TEXTO INFORMADO POR UM USUÁRIO E QUE SERÁ EXIBIDO PARA OUTROS USUÁRIOS
   * @param text to be sanitized
   */
  public static sanitize(text: string) {
    return text
      .trim()
      .replace(/</g, '˂')
      .replace(/>/g, '˃')
      .replace(/script/ig, 'ѕϲrірt')
      .replace(/style/ig, 'ѕtyle');
  }

  public static alternativeValidateEmail(email: string) {
    if (!email || email.includes(' ') || email !== this.normalize(email)) {
      return false;
    }
    const params = email.split('@');
    return params.length === 2 &&
           params[0].length >= 1 &&
           params[1].length >= 3 &&
           params[1].includes('.') &&
          !params[0].startsWith('.') &&
          !params[0].endsWith('.') &&
          !params[1].startsWith('.') &&
          !params[1].endsWith('.');
  }

  public static textCase(text: string) {
    return capitalize(text);
    // text = text.toLowerCase();
    // let chars = text.split('');
    // if (!chars.length) {
    //   chars = [''];
    // }
    // chars[0] = chars[0].toUpperCase();
    // return chars.join('');
  }

  public static arrayToListText(array: (string | number)[]) {
    const lastEl = array.pop();
    const listText = array.join(', ');
    return listText + ' e ' + lastEl;
  }

  /**
   * Padroniza strings para serem comparadas
   */
  public static clean(item: string) {
    return this.normalize(item || '')
               .trim()
               .toUpperCase()
               .replace(/ /g, '');
  }

  public static turnIntoHTML(text: string) {
    text = this.sanitize(text);

    if (text.includes('\n')) {
      text = text.replace(/\n/g, ' <br> ');
    }

    if (text.includes('https://')) {
      const content: string[] = text.split(' ').map(item => {
        if (item.startsWith('https://')) {
          return `<a href="${ item }" target="_blank" class="text-info" style="line-break: anywhere;">${ item }</a>`
        }
        return item;
      });
      text = content.join(' ');
    }

    return text;
  }

  public static truncate(text: string, maxLength: number): string {
    if (text.length > maxLength) {
      return text.slice(0, maxLength - 3) + '...';
    } else {
      return text;
    }
  }

}
